/* eslint-disable react/display-name */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const FilterSubscriptionCustomValue = React.memo(({ children, ...props }) => {
    const { t: translate } = useTranslation();
    const { selectProps, data } = props;
    const { value } = selectProps;

    // Memoize the overall subscription label to avoid recalculating it on every render
    const overallSubscriptionLabel = useMemo(() => {
        // If there is only one selected value, render the children directly
        if (value?.length === 1) {
            return children;
        }

        if (value?.length > 1 && data === value[0]) {
            const subscriptionLabel = translate('ABB.Powertrain.Frontend.subscriptionsLabel');
            return (
                <div className='overall-subscription'>
                    +{value?.length} {subscriptionLabel}
                </div>
            );
        }
        return null;
    }, [value, data]);

    // Render the custom value container
    return (
        <components.MultiValueContainer {...props}>
            {overallSubscriptionLabel}
        </components.MultiValueContainer>
    );
});

FilterSubscriptionCustomValue.propTypes = {
    selectProps: PropTypes.shape({
        value: PropTypes.arrayOf(PropTypes.any),
    }),
    data: PropTypes.any,
    children: PropTypes.node,
};

export default FilterSubscriptionCustomValue;
